module.exports = __webpack_public_path__ + "static/media/paladin_head.94ae5333.svg";